var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9727 11.3427L13.3164 14.1044C13.2344 14.5145 12.9062 14.788 12.4961 14.788C5.60547 14.7606 0 9.15516 0 2.26453C0 1.85438 0.246094 1.52625 0.65625 1.44422L3.41797 0.787972C3.80078 0.705941 4.21094 0.924691 4.375 1.28016L5.66016 4.26063C5.79688 4.6161 5.71484 5.02625 5.41406 5.245L3.9375 6.44813C4.86719 8.33485 6.39844 9.8661 8.3125 10.7958L9.51562 9.31922C9.73438 9.04578 10.1445 8.93641 10.5 9.07313L13.4805 10.3583C13.8359 10.5497 14.0547 10.9598 13.9727 11.3427Z",
    fill: "#F64A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.86277e31e955dba2934ebaab6d2e611d.svg";
export { ForwardRef as ReactComponent };